import React, { Component } from 'react';
import TetherComponent from 'react-tether';
import PropTypes from 'prop-types';
import { List } from 'react-virtualized';
import { ReactPageClick } from 'react-page-click';
import joinClasses from 'classnames';
import _ from 'lodash';

const FilterBody = ({
	isUsingOption,
	onSelectAll,
	filterText,
	toggleOption,
	items,
}) => {
	const rowRenderer = ({ key, index, style }) => {
		const item = items[index];
		const isUsing = isUsingOption(item);
		return (
			<li key={key} style={style}>
				<span
					className={isUsing ? 'is-active' : ''}
					onClick={(e) => {
						if (item && item.value === '__selectall__') {
							onSelectAll(isUsing, filterText);
						} else {
							toggleOption(e, isUsing, item);
						}
					}}
				>
					{item && item.label ? item.label : ''}
				</span>
			</li>
		);
	};

	return (
		<List
			className="dropdown-portal-body"
			height={260}
			rowCount={items.length}
			rowHeight={25}
			rowRenderer={rowRenderer}
			width={400}
		/>
	);
};

FilterBody.propTypes = {
	items: PropTypes.any.isRequired,
	isUsingOption: PropTypes.func,
	toggleOption: PropTypes.func,
	filterText: PropTypes.string,
	onSelectAll: PropTypes.func.isRequired,
};

FilterBody.defaultProps = {
	isUsingOption: () => {},
	toggleOption: () => {},
	filterText: '',
};

class FilterPortal extends Component {
	static propTypes = {
		onHiddenDropdown: PropTypes.func,
		onShowDropdown: PropTypes.func,
		onConfirm: PropTypes.func,
		onClear: PropTypes.func,
		data: PropTypes.any.isRequired,
		isUsingOption: PropTypes.func.isRequired,
		toggleOption: PropTypes.func.isRequired,
		onSelectAll: PropTypes.func.isRequired,
		filterKeys: PropTypes.array.isRequired,
		hasFilter: PropTypes.bool,
		renderHeaderTitle: PropTypes.func.isRequired,
		renderAdvancedFilter: PropTypes.func,
		isAdvanced: PropTypes.bool,
		iconClass: PropTypes.string,
	};

	static defaultProps = {
		onHiddenDropdown: () => {},
		onShowDropdown: () => {},
		onConfirm: null,
		onClear: null,
		hasFilter: false,
		isAdvanced: false,
		iconClass: null,
		renderAdvancedFilter: () => {},
	};

	state = {
		isOpen: false,
		data: this.props.data,
		filteredData: null,
		filterText: '',
	};

	static getDerivedStateFromProps(props, state) {
		if (!_.isEqual(state.data, props.data)) {
			return {
				data: props.data,
			};
		}
		return null;
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.isOpen !== this.state.isOpen && this.state.isOpen) {
			this.props.onShowDropdown();
		}
	}

	close = () => {
		if (this.state.isOpen) {
			this.setState({
				isOpen: false,
				filteredData: null,
				filterText: '',
			});
		}
	};

	confirm = () => {
		this.props.onConfirm();
		this.close();
	};

	clear = () => {
		this.props.onClear();
		this.close();
	};

	filter = (item, filterText, keys) => {
		const filtered = keys.filter((key) => {
			const value = `${item[key]}`;
			if (value === '__selectall__') return true;
			return value.toLowerCase().indexOf(filterText.toLowerCase()) >= 0;
		});
		return filtered && filtered.length;
	};

	filterData = _.debounce(
		() => {
			const { filterKeys } = this.props;
			const { data } = this.props;
			const newData = data.filter((item) =>
				this.filter(item, this.state.filterText, filterKeys),
			);
			this.setState({ filteredData: newData });
		},
		100,
		{ leading: false, trailing: true },
	);

	handleSearchChange = ({ target: { value: filterText } }) => {
		this.setState({ filterText });
		this.filterData(filterText);
	};

	toggle = (e) => {
		e.nativeEvent.stopImmediatePropagation();
		this.setState((state) => ({ isOpen: !state.isOpen }));
	};

	PortalHeader = () => {
		return (
			<div className="dropdown-portal-header">
				<div className="dropdown-portal-title">
					{this.props.renderHeaderTitle()}
					<div className="dropdown-portal-buttons">
						{this.props.onConfirm && (
							<button
								type="button"
								className="btn btn-aplicar btn-sm"
								onClick={this.confirm}
							>
								Aplicar
							</button>
						)}
						{this.props.onClear ? (
							<button type="button" className="btn btn-sm" onClick={this.clear}>
								Limpar
							</button>
						) : (
							<button type="button" className="btn btn-sm" onClick={this.close}>
								Cancelar
							</button>
						)}
					</div>
				</div>
			</div>
		);
	};

	renderToggle = (ref) => {
		const filterClass = joinClasses({
			'fa fa-filter': !this.props.hasFilter,
			'fa fa-filter-active': this.props.hasFilter,
		});

		const className = this.props.iconClass ? this.props.iconClass : filterClass;

		return (
			<span
				ref={ref}
				onClick={(e) => this.toggle(e)}
				className="dropdown-portal-toggle"
			>
				<span className="icon">
					<i className={className} />
				</span>
			</span>
		);
	};

	PortalBody = () => {
		const { filteredData, filterText, data } = this.state;
		return (
			<FilterBody
				items={filteredData || data}
				isUsingOption={this.props.isUsingOption}
				toggleOption={this.props.toggleOption}
				filterText={filterText}
				onSelectAll={this.props.onSelectAll}
			/>
		);
	};

	render() {
		const { isOpen } = this.state;
		const { isAdvanced } = this.props;
		const { PortalHeader, PortalBody } = this;
		return (
			<TetherComponent
				style={{ zIndex: 2000 }}
				attachment="top right"
				targetAttachment="bottom left"
				constraints={[
					{
						to: 'window',
						attachment: 'together',
					},
				]}
				renderTarget={this.renderToggle}
				renderElement={(ref) =>
					isOpen && (
						<ReactPageClick ref={ref} notify={this.close}>
							<div className="dropdown-portal has-header">
								<PortalHeader />
								{!isAdvanced && (
									<div className="dropdown-portal-search">
										<div className="search-input">
											<input
												id="filter-text"
												name="filter-text"
												className="form-control"
												type="text"
												placeholder="Search"
												value={this.state.filterText}
												onChange={this.handleSearchChange}
												onFocus={(e) => {
													e.nativeEvent.stopImmediatePropagation();
												}}
											/>
										</div>
									</div>
								)}
								{!isAdvanced && <PortalBody />}
								{isAdvanced && this.props.renderAdvancedFilter()}
							</div>
						</ReactPageClick>
					)
				}
			/>
		);
	}
}

export default FilterPortal;
